import React from "react";
import "../BlockChain/Blockchain.css";
import { NavLink } from "react-router-dom";
import {
  FiArrowRight,
  FiPlay,
  FiMonitor,
  FiSmartphone,
  FiBox,
} from "react-icons/fi";

const GamePage = () => {
  return (
    <div className="sub-service-page">
      <div className="page-bg-engine">
        <div className="theme-orb orb-primary"></div>
        <div className="theme-orb orb-secondary"></div>
      </div>
      {/* --- Section 1: Sovereign Hero --- */}
      <section className="sub-hero">
        <div className="v2-container">
          <div className="sub-hero-content">
            <div className="v3-badge">Creative Studio</div>
            <h1 className="title-reveal">
              Engineering <span className="blue-glow">Immersive</span> Worlds
            </h1>
            <p className="v3-hero-p-centered">
              We push the boundaries of immersion with enterprise-grade 2D/3D
              development. Our studio creates next-gen gaming experiences for
              PC, Mobile, and Console.
            </p>
          </div>
        </div>
      </section>

      {/* --- Section 2: Intro --- */}
      <section className="sub-content-section">
        <div className="v2-container">
          <div className="content-layout-left">
            <h2 className="v3-title">
              Leading the <span className="blue-glow">Next-Gen</span> Gaming
            </h2>
            <p className="v3-p-text">
              Offering a comprehensive suite of game development services
              powered by Unity and Unreal Engine. We are dedicated to creating
              entertaining, engaging, and technically flawless interactive
              media.
            </p>

            <div className="tech-stack-strip">
              <img src="/game1.png" alt="Icon 1" />
              <img src="/ame3.png" alt="Icon 2" />
              <img src="/game4.jpeg" alt="Icon 3" />
              <img src="/game5.jpeg" alt="Icon 4" />
            </div>
          </div>
        </div>
      </section>

      {/* --- Section 3: Feature Grid --- */}
      <section className="sub-features-section">
        <div className="v2-container">
          <div className="feature-grid-sub">
            <div className="feature-card-sub">
              <div className="f-icon-box">
                <FiMonitor />
              </div>
              <h3>PC Game Development</h3>
              <p>
                Full-service video game development from concept to deployment
                using cutting-edge physics and graphics engines.
              </p>
            </div>

            <div className="feature-card-sub">
              <div className="f-icon-box">
                <FiSmartphone />
              </div>
              <h3>Mobile Game Systems</h3>
              <p>
                Specialized high-performance logic for iOS and Android, focusing
                on intuitive UX and cross-platform synergy.
              </p>
            </div>

            <div className="feature-card-sub">
              <div className="f-icon-box">
                <FiBox />
              </div>
              <h3>AR/VR/MR Mastery</h3>
              <p>
                Architecting spatially-aware interactive experiences using the
                latest spatial computing and emerging tech.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* --- Section 4: Detailed Rows --- */}
      <section className="sub-platforms">
        <div className="v2-container">
          <div className="platform-row">
            <div className="platform-text">
              <h2 className="v3-title">
                High-Performance <span className="blue-glow">PC Porting</span>
              </h2>
              <p className="v3-p-text">
                We use advanced technology stack to produce aesthetically
                appealing and entertaining games that utilize full hardware
                potential.
              </p>
              <NavLink to="/contactus" className="btn-secondary">
                Get a Quote <FiArrowRight />
              </NavLink>
            </div>
            <div className="platform-visual">
              <div className="visual-indicator-ring"></div>
              <FiPlay
                style={{ fontSize: "10rem", color: "#0066ff", opacity: 0.4 }}
              />
            </div>
          </div>

          <div className="platform-row reverse">
            <div className="platform-text">
              <h2 className="v3-title">
                Spatial <span className="blue-glow">Computing</span>
              </h2>
              <p className="v3-p-text">
                Our developers are experts in creating technically sound and
                visually stunning AR/VR/MR games for emerging global platforms.
              </p>
              <NavLink to="/contactus" className="btn-secondary">
                Initialize Build <FiArrowRight />
              </NavLink>
            </div>
            <div className="platform-visual">
              <FiBox
                style={{ fontSize: "10rem", color: "#6366f1", opacity: 0.4 }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* --- Section 5: Tech strip bottom --- */}
      <section
        className="sub-content-section"
        style={{ background: "rgba(15,23,42,0.2)" }}
      >
        <div className="v2-container">
          <div className="content-layout-left center-text-mobile">
            <h2 className="v3-title">
              Our <span className="blue-glow">Core Engine</span> Tech
            </h2>
            <div className="tech-stack-strip">
              <img src="/c++.png" alt="C++" />
              <img src="/chash.png" alt="C#" />
              <img src="/java.png" alt="Java" />
              <img src="/python.png" alt="Python" />
            </div>
          </div>
        </div>
      </section>

      {/* --- Section 6: Universal CTA --- */}
      <section className="v3-final-cta">
        <div className="v2-container">
          <div className="v3-cta-card">
            <div className="v3-cta-content">
              <h2 className="v3-cta-title">
                Bring your world <br />
                <span className="grad-blue">to life today.</span>
              </h2>
              <NavLink to="/contactus" className="v3-main-btn">
                <span>Consult Studio</span>
                <div className="btn-icon-box">
                  <FiArrowRight />
                </div>
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GamePage;
